import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { ConsumerTimelineProvider } from '../../providers/consumer-timeline-handler';
import { BaseListPage } from '../../providers/base-list-page';
import { Globals } from '../../providers/globals';
import { ConsumerMessageDetailPage } from '../../pages/consumer-message-detail/consumer-message-detail';

declare var google: any;

@Component({
  selector: 'page-consumer-message-timeline',
  templateUrl: 'consumer-message-timeline.html',
})
export class ConsumerMessageTimelinePage extends BaseListPage {
	messages: any;
  	hasMessages: boolean = false;

	constructor(
		public globals: Globals,
		public consumerTimelineProvider: ConsumerTimelineProvider,
		public navCtrl: NavController, 
		public navParams: NavParams) {
		super();
	    this.isLoading = true;
	  	this.load(null);	
	}

  	ionViewDidEnter() {
  	}  	

	ionViewDidLoad() {
		console.log('ionViewDidLoad ConsumerMessageTimelinePage');
	}

	doRefresh(refresher) {
		this.params.page = 1;

		this.isRefreshing = true;

		this.load(()=>{
			this.isRefreshing = false;			
		  	refresher.complete();
		});
	}    

	doInfinite(infiniteScroll){
		if(!this.lastRequestReturnedValues){
		  infiniteScroll.complete();
		  return;
		} 

		this.params.page++;
		this.isFetchingMore = true;
		
		this.load(()=>{
		  infiniteScroll.complete();
		});
	}

	load(cb){
		this.isLoading = (!this.isRefreshing && !this.isFetchingMore) ? true : false;

		this.params.cbAfter = cb;

		this.consumerTimelineProvider.getTimeline(this.params);
	}	

	viewMessageDetail(message) {
		this.navCtrl.push(ConsumerMessageDetailPage, {
		  message: message
		})
	}	
}



// WEBPACK FOOTER //
// ./src/pages/consumer-message-timeline/consumer-message-timeline.ts